import React, { Dispatch, MutableRefObject } from "react";
import Bio from "../Bio";
import Geography from "../Geography";
import License from "../License";
import Awards from "../Awards";
import Leader from "../Leader";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import { BrokerProps, ProfileProps } from "types";
import { ContentArea } from "../ContentEditor";
import CopyProfile from "./CopyProfile";

type NavigationProps = {
  broker: BrokerProps | null;
  profiles: ProfileProps[] | null;
  selectedProfile: ProfileProps | null;
  setSelectedProfile: Dispatch<ProfileProps | null>;
  isProfileLoading?: boolean;
  reloadBroker: () => void;
  setBroker: Dispatch<BrokerProps | null>;
  subActiveTab: string;
  handleSubTab: (tab: string) => void;
  handleConfirmPublish: () => void;
  bioRef: MutableRefObject<any>;
};

const Navigation: React.FC<NavigationProps> = ({
  broker,
  selectedProfile,
  setSelectedProfile,
  isProfileLoading,
  reloadBroker,
  subActiveTab,
  handleSubTab,
  handleConfirmPublish,
  bioRef,
  setBroker,
  profiles,
}) => {
  const handleTabChange = (tabValue: string) => {
    handleSubTab(tabValue);
  };

  const tabs = [
    {
      label: "Region & Title",
      value: "geography",
      component: (
        <Geography
          profile={selectedProfile}
          setProfile={setSelectedProfile}
          isLoading={isProfileLoading}
          broker={broker}
          setBroker={setBroker}
        />
      ),
    },
    {
      label: "About",
      value: "bio",
      component: (
        <Bio
          profile={selectedProfile}
          setProfile={setSelectedProfile}
          isLoading={isProfileLoading}
          broker={broker}
          ref={bioRef}
          reloadBroker={reloadBroker}
        />
      ),
    },
    {
      label: "Featured Work",
      value: "featured_work",
      component: (
        <ContentArea
          profile={selectedProfile}
          setProfile={setSelectedProfile}
          isLoading={isProfileLoading}
          broker={broker}
          reloadBroker={reloadBroker}
          profile_key="featured_work"
        />
      ),
    },
    {
      label: "Awards",
      value: "awards",
      component: (
        <Awards
          profile={selectedProfile}
          setProfile={setSelectedProfile}
          broker={broker}
          reloadBroker={reloadBroker}
          isLoading={isProfileLoading}
        />
      ),
    },
    {
      label: "Affiliations",
      value: "affiliations",
      component: (
        <ContentArea
          profile={selectedProfile}
          setProfile={setSelectedProfile}
          isLoading={isProfileLoading}
          broker={broker}
          reloadBroker={reloadBroker}
          profile_key="affiliations"
        />
      ),
    },
    {
      label: "Education",
      value: "education",
      component: (
        <ContentArea
          profile={selectedProfile}
          setProfile={setSelectedProfile}
          isLoading={isProfileLoading}
          broker={broker}
          reloadBroker={reloadBroker}
          profile_key="education"
        />
      ),
    },
    // {
    //   label: "License",
    //   value: "license",
    //   component: (
    //     <License
    //       profile={selectedProfile}
    //       setProfile={setSelectedProfile}
    //       isLoading={isProfileLoading}
    //     />
    //   ),
    // },
    // {
    //   label: "Leader",
    //   value: "leader",
    //   component: (
    //     <Leader
    //       profile={selectedProfile}
    //       setProfile={setSelectedProfile}
    //       isLoading={isProfileLoading}
    //       broker={broker}
    //     />
    //   ),
    // },
  ];

  return (
    <>
      <div className="px-10 pt-8 flex flex-row items-center justify-between">
        <p className="w-1/2 text-jll-text-base-subdued">
          This section lets you customize how your profile appears for a
          specific country site and in a specific language. Changes here won't
          affect your profile in other regions.
        </p>
        <CopyProfile
          profiles={profiles}
          selectedProfileId={selectedProfile?.id}
          setSelectedProfile={setSelectedProfile}
        />
      </div>
      <div className="h-full px-10 pt-8">
        <TabGroup
          vertical
          className="flex flex-row w-full h-full"
          selectedIndex={tabs.findIndex((tab) => tab.value === subActiveTab)}
          onChange={(index) => handleTabChange(tabs[index].value)}
        >
          <TabList className="flex flex-col w-1/5 h-full border-r">
            {tabs.map((tab) => (
              <Tab
                key={tab.value}
                className={({ selected }) =>
                  `w-full py-2 px-4 text-left focus:outline-none ${
                    selected
                      ? "text-jll-text-base-default border-r border-jll-text-base-default"
                      : "text-jll-text-base-subdued"
                  }`
                }
              >
                {tab.label}
              </Tab>
            ))}
          </TabList>
          <TabPanels className="flex-grow w-4/5 p-4">
            {tabs.map((tab) => (
              <TabPanel key={tab.value} className="">
                {tab.component}
              </TabPanel>
            ))}
          </TabPanels>
        </TabGroup>
      </div>
    </>
  );
};

export default Navigation;
